import { Component, OnInit } from '@angular/core';

import { Widget, Dashboard, DashboardListItem, SiteType, SiteTwin } from 'src/api/models'
import { DashboardService, SiteTypeService } from 'src/api/services';
import { IWidgetEditor, WidgetType, TimeSeriesDetail } from "src/app/models/dashboard";
import { ApplicationConfigService } from 'src/service/application-config.service';

@Component({
  selector: 'app-dashboard-widget-editor',
  templateUrl: './dashboard-widget-editor.component.html',
  styleUrls: ['./dashboard-widget-editor.component.css']
})
export class DashboardWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: Widget;
  public dashboard: Dashboard;
  public siteTypes: SiteType[];
  public siteType: SiteType;
  public w: any;
  public active: TimeSeriesDetail;
  public dashboards: Dashboard[];
  public selectedDashboard: Dashboard;
  public sites: SiteTwin[];

  constructor(public dashboardService: DashboardService, public siteTypeService: SiteTypeService, public app: ApplicationConfigService) { }

  ngOnInit() {
    this.w = <any>this.widget;
    //this.active = this.w.timeSeries;

    this.siteTypeService.SiteTypeGetAll(this.app.customerId ?? 0).subscribe(s => {
      this.siteTypes = s;
    
      this.dashboardService.DashboardGetCustomerDashboards(this.app.customerId).subscribe(results => {
        //this.dashboards = r;
        this.dashboards = results.filter(dd=> dd.dashboardId != this.dashboard.dashboardId);//.map<DashboardListItem>(dd => ({ dashboardId: dd.dashboardId, name: dd.name, public:dd.publishedToPublic, index:0, displaySeconds:60, dashboardListItemId:0}));
        
        this.populateSites();
      });
    });
  }

  populateSites(){
    this.selectedDashboard = this.dashboards.find(d => d.dashboardId == this.w.dashboardId);
    if (this.selectedDashboard.siteType){
      this.siteType = this.siteTypes.find(st => st.siteTypeCode == this.selectedDashboard.siteType);
      this.siteTypeService.SiteTypeSearch({
        customerId:this.app.customerId, 
        searchSize:200, 
        type: this.siteType.siteTypeCode, 
        pageIndex: 0,
        search:'',filterOld:true,sortColumn:null, sortOrder: null
      } as SiteTypeService.SiteTypeSearchParams).subscribe(r => {
        this.sites = r;
      });
    } else {
      this.siteType = null;
      this.sites = null;
    }
  }



}
